module.exports = {"fb_pixel_id":"351922425536005"}


//////////////////
// WEBPACK FOOTER
// ./src/config/constants.json
// module id = 1474
// module chunks = 0